/* Package JSON Import will be here */
import { createStore, applyMiddleware, compose } from "redux";
import { routerMiddleware } from "connected-react-router";
import thunk from "redux-thunk";
import { initialize, addTranslationForLanguage, setActiveLanguage } from "react-localize-redux";
import ReactGA from 'react-ga4';
/* Package JSON Import will be here */

/* Project Import will be here */
import { default as rootReducer, history } from "./rootReducer";
import { loadState, saveState } from "./localStorage";
import { GASetUserId, GAPageView } from "hooks/googleAnalyticsHooks";
import { enOverride, deOverride, esOverride } from "../assets/localeData/localeDataOverride";
import { getCurrentPageTitle } from "utilities/utils";
/* Project Import will be here */

/* Const,Let & Var will be here */
let initialState = loadState();
const enhancers = [];
const middleware = [thunk, routerMiddleware(history)];
/* Const,Let & Var will be here */

if (process.env.NODE_ENV === "development") {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

  if (typeof devToolsExtension === "function") {
    enhancers.push(devToolsExtension());
  }
}

/* Check for google analytics is enabled */
if (window.isEnableGA) {
  /* Initialize google analytics Tracking id and Ecommerce plugin*/
  ReactGA.initialize([
    {
      trackingId: window.GATrackingId,
      gaOptions: {
        "debug_mode": true,
        "cookie_flags": 'SameSite=None;Secure'
      }
    }
  ]);

  /* Assign UserId if retailer already logged-in in the system */
  if (initialState && initialState.localStore.user !== null)
    GASetUserId(initialState.localStore.user.retailerid);
}

const gaTrackingMiddleware = store => next => action => {
  /* Register page view event on every route change */
  if (window.isEnableGA && action.type === '@@router/LOCATION_CHANGE') {
    const pageTitle = getCurrentPageTitle(action.payload.location.pathname);
    const pagePath = `${action.payload.location.pathname}${action.payload.location.search}`;
    GAPageView(pageTitle, pagePath);
  }

  return next(action);
};

/* redux Middleware */
const composedEnhancers = compose(applyMiddleware(gaTrackingMiddleware), applyMiddleware(...middleware), ...enhancers);

/* Subscribe Store */
const store = createStore(rootReducer, initialState, composedEnhancers);
let tempState = {};
if (initialState) {
  tempState = initialState;
}
store.subscribe(() => {
  if (tempState !== store.getState().localStore) {
    saveState({ localStore: store.getState().localStore });
    tempState = store.getState().localStore;
  }
});

/* Initialize for multiple language configuration */
const { languages } = window;

// TODO: need to analyze and remove the bellow commented line
/* eslint-disable no-template-curly-in-string */
store.dispatch(initialize(languages, { missingTranslationMsg: "${key}" }));
store.dispatch(addTranslationForLanguage(enOverride(), "en_US"));
store.dispatch(addTranslationForLanguage(deOverride(), "de"));
store.dispatch(addTranslationForLanguage(esOverride(), "es"));

/* Check for default language setup, If no language is selected select the english as default language */
const defaultLang = store.getState().localStore.defaultLang;
if (!defaultLang) {
  store.dispatch(setActiveLanguage(languages[0]["code"]));
}

/* Set language from local storage */
const selectedLangCode = localStorage.getItem("selectedLanguageCode");
if (selectedLangCode) {
  store.dispatch(setActiveLanguage(selectedLangCode));
}

export default store;